import { onboardingReducer } from './reducer';
import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';

const middlewares = [ thunk ];

const composeEnhancers =
  typeof window === 'object' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({})
    : compose;

const enhancer = (...middlewares) =>
  composeEnhancers(
    applyMiddleware(...middlewares)
  );
  
export const createReduxStore = createStore(onboardingReducer, enhancer(...middlewares));
